module.exports = __webpack_public_path__ + "assets/img/triple_half_r.032a70c4.svg";